import { CoreIcon } from '../core-icon';
import invoiceSVG from '../../assets/icons/invoice.svg';
import type { IconProps } from '../core-icon';

export const InvoiceIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={invoiceSVG} {...props} />;
};
